module.exports = __webpack_public_path__ + "img/hexagon-fill.2ef1e692.svg";